import { useTranslation } from 'react-i18next'
import { NS } from '~/enums'

export const usePassProductTranslations = () => {
  const { t } = useTranslation()

  const discount = t('discount', { ns: NS.ORDERS_PAYMENTS })
  const popular = t('most_popular', { ns: NS.CHALLENGES })
  const account_size = t('account_size', { ns: NS.CHALLENGES })
  const valid_until = t('valid_until', { ns: NS.CHALLENGES })
  const pass_details = t('pass_details', { ns: NS.CHALLENGES })
  const banner_title = t('banner_title', { ns: NS.CHALLENGES })

  const passProductTranslationMappings: {
    [key: number]: {
      description: string
      details: string
      popular: boolean
      accountSize: string
    }
  } = {
    103: {
      //SILVER
      description: t('silver_pass_description', { ns: NS.CHALLENGES }),
      details: t('silver_pass_details', { ns: NS.CHALLENGES }),
      popular: false,
      accountSize: t('silver_account_size', { ns: NS.CHALLENGES }),
    },
    104: {
      //GOLD
      description: t('gold_pass_description', { ns: NS.CHALLENGES }),
      details: t('gold_pass_details', { ns: NS.CHALLENGES }),
      popular: true,
      accountSize: t('gold_account_size', { ns: NS.CHALLENGES }),
    },
  }

  return {
    discount,
    popular,
    account_size,
    valid_until,
    pass_details,
    passProductTranslationMappings,
    banner_title,
  }
}
